<template>
  <b-modal ref="newMessage" centered size="lg" id="newMessage" :title="modalTitle" @show="setDefaults" @hide="checkIfSending" hide-footer>
    <NewMessage v-if="shown" :mailbox="mailbox" parent="modal"/>
  </b-modal>
</template>

<script>
import NewMessage from './NewMessage'
import {mapMutations, mapGetters} from 'vuex'

export default {
  name: 'NewMessageModal',
  props: ['mailbox'],
  data () {
    return {
      shown: false
    }
  },
  components: {
    NewMessage
  },
  computed: {
    modalTitle () {
      return 'New Message - ' + this.mailbox.name
    },
    ...mapGetters(['messageSending'])
  },
  methods: {
    ...mapMutations(['setDefaultDraft', 'setDefaultMessageForm', 'setSendingStatus']),
    setDefaults () {
      this.$root.$emit('destroyMessageForm')
      this.setDefaultDraft()
      this.setDefaultMessageForm()
      this.shown = true
    },
    checkIfSending (event) {
      if (this.messageSending) {
        let answer = window.confirm('Do you really want to leave? you have unsaved changes!')
        if (!answer) {
          event.cancel()
        } else {
          this.shown = false
        }
      } else {
        this.shown = false
        this.setSendingStatus(false)
      }
    }
  },

  beforeDestroy () {
    this.$store.commit('setForwardedMessage', false)
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/NewMessageModal.vue